module.exports = __webpack_public_path__ + "static/media/red-whiskered-bulbul.b6042b31.png";